import { Component } from '@angular/core';


/**
* Fallback page component when requested URL doesn't match any router paths
*/
@Component({
  selector: 'app-fallback',
  template: `<p class="alert alert-warning">This is the <strong>🕳️ FALLBACK</strong> component.</p>`,
})
export class FallbackComponent { }
